import { render, staticRenderFns } from "./data_classStudent.vue?vue&type=template&id=79dbeae4&scoped=true&"
import script from "./data_classStudent.vue?vue&type=script&lang=js&"
export * from "./data_classStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dbeae4",
  null
  
)

export default component.exports